import React, { useContext, useEffect, useState } from "react";
import { Button, Form, Input, Select } from "antd";
import ModalTags from "../GeoUnit/ModalTags";
import { context } from "../../context/context";
import { http } from "../../services/httpService";
import config from "../../services/config.json";
import TextEditorModal from "./../Place/TextEditorModal";

const TravelForm = () => {
    const [form] = Form.useForm();
    // state
    const [isEditSelected, setIsEditSelected] = useState(false);
    const [places, setPlaces] = useState([]);
    const [selectPlaces, setSelectPlaces] = useState([]);
    const [content, setContent] = useState([]);
    const [selectContent, setSelectContent] = useState([]);
    const [geo, setGeo] = useState([]);
    const [selectGeo, setSelectGeo] = useState([]);
    const [inputTitleStyle, setInputTitleStyle] = useState({
        width: "100%",
        outline: "0",
    });
    // context
    const {
        travelMedia,
        setTextEditorShow,
        setTextEditorHTML,
        travelTitle,
        travelContent,
        travelGeo,
        travelPlaces,
        travelTime,
        setTravelTitle,
        setTravelContent,
        setTravelGeo,
        setTravelPlaces,
        setTravelTime,
        selectedTravelId,
        setTravelTags,
        setTravelCover,
        setTravelMedia,
    } = useContext(context);
    // useEffect
    useEffect(() => {
        http.get(`${config.parkopoloApi}/api/Place/`)
            .then((res) => {
                const placeTitles = [];
                res.data.result.map((p) => {
                    placeTitles.push({ value: p.title, label: p.title });
                });
                setSelectPlaces(placeTitles);
                setPlaces(res.data.result);
            })
            .catch((err) => {
                console.log(err);
            });
        http.get(`${config.parkopoloApi}/api/Content/`)
            .then((res) => {
                const contentTitles = [];
                res.data.result.map((c) => {
                    contentTitles.push({ value: c.title, label: c.title });
                });
                setSelectContent(contentTitles);
                setContent(res.data.result);
            })
            .catch((err) => {
                console.log(err);
            });
        http.post(`${config.parkopoloApi}/api/Travel/geopolitics`)
            .then((res) => {
                const geoTitles = [];
                res.data.result.map((g) => {
                    geoTitles.push({
                        value: g.name,
                        label: g.name,
                    });
                });
                setSelectGeo(geoTitles);
                setGeo(res.data.result);
            })
            .catch((err) => {
                console.log(err);
            });
        if (selectedTravelId) {
            http.get(`${config.parkopoloApi}/api/Travel/${selectedTravelId}`)
                .then((res) => {
                    console.log(res);
                    setTravelTitle(res.data.result.title);
                    setTravelTags(res.data.result.tags);
                    setTextEditorHTML(res.data.result.data);
                    setTravelCover([res.data.result.coverPic]);
                    setTravelMedia(res.data.result.media);
                })
                .catch((err) => {
                    console.log(err);
                });
            setIsEditSelected(true);
        }
    }, []);
    console.log(travelMedia);
    // functions
    const handleTitleChange = (e) => {
        setTravelTitle(e.target.value);
    };
    const handleChangeTime = (value) => {
        setTravelTime(value);
    };
    const handleChangePlace = (value) => {
        const filteredPlaces = [];
        value.map((v) => {
            places.map((p) => {
                if (p.title === v) {
                    filteredPlaces.push(p._id);
                }
            });
        });
        setTravelPlaces(filteredPlaces);
    };
    const handleChangeContent = (value) => {
        const filteredContent = [];
        value.map((v) => {
            content.map((c) => {
                if (c.title === v) {
                    filteredContent.push(c._id);
                }
            });
        });
        setTravelContent(filteredContent);
    };
    const handleChangeGeo = (value) => {
        const filteredGeo = [];
        value.map((v) => {
            geo.map((g) => {
                if (g.name === v) {
                    filteredGeo.push(g._id);
                }
            });
        });
        setTravelGeo(filteredGeo);
    };
    return (
        <div
            style={{
                direction: "rtl",
                display: "flex",
                gap: "15px",
                margin: "15px",
            }}
        >
            <Form
                layout="vertical"
                form={form}
                name="control-hooks"
                style={{
                    width: "100%",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        gap: "2rem",
                        alignItems: "center",
                    }}
                >
                    <Form.Item
                        name="عنوان"
                        label="عنوان"
                        style={{ width: "100%" }}
                    >
                        <h4 style={{ display: "none" }}>{travelTitle}</h4>
                        <input
                            style={inputTitleStyle}
                            className="ant-input css-dev-only-do-not-override-lzp0br css-dev-only-do-not-override-lzp0br"
                            type="text"
                            value={isEditSelected ? travelTitle : null}
                            onChange={handleTitleChange}
                            placeholder="عنوان را وارد کنید"
                            onFocus={() => {
                                const updatedStyle = {
                                    ...inputTitleStyle,
                                    outline: "1px solid #48D1CC",
                                    borderColor: "#48D1CC",
                                };
                                setInputTitleStyle(updatedStyle); // assuming setInputStyle is a setter function to update inputStyle
                            }}
                            onBlur={() => {
                                const updatedStyle = {
                                    ...inputTitleStyle,
                                    outline: "",
                                    borderColor: "",
                                };
                                setInputTitleStyle(updatedStyle); // assuming setInputStyle is a setter function to update inputStyle
                            }}
                            onMouseEnter={() => {
                                const updatedStyle = {
                                    ...inputTitleStyle,
                                    borderColor: "#48D1CC",
                                };
                                setInputTitleStyle(updatedStyle); // assuming setInputStyle is a setter function to update inputStyle
                            }}
                            onMouseLeave={() => {
                                const updatedStyle = {
                                    ...inputTitleStyle,
                                    borderColor: "",
                                };
                                setInputTitleStyle(updatedStyle); // assuming setInputStyle is a setter function to update inputStyle
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        name="انتخاب تعداد روزها"
                        label="انتخاب تعداد روزها"
                        style={{ width: "100%" }}
                    >
                        <Select
                            mode="multiple"
                            style={{
                                width: "100%",
                            }}
                            defaultValue={selectedTravelId ? travelTime : []}
                            onChange={handleChangeTime}
                            tokenSeparators={[","]}
                            options={[
                                { value: 1, label: "یک روز" },
                                { value: 2, label: "دو روز" },
                                { value: 3, label: "سه روز" },
                                { value: 4, label: "چهار روز" },
                                { value: 5, label: "پنج روز" },
                                { value: 6, label: "شش روز" },
                            ]}
                        />
                    </Form.Item>
                </div>

                <Form.Item
                    name="انتخاب مکان ها"
                    label="انتخاب مکان ها"
                    style={{ width: "100%" }}
                >
                    <Select
                        defaultValue={
                            selectedTravelId
                                ? travelPlaces.map((p) => p.title)
                                : []
                        }
                        mode="multiple"
                        style={{
                            width: "100%",
                        }}
                        onChange={handleChangePlace}
                        tokenSeparators={[","]}
                        options={selectPlaces}
                    />
                </Form.Item>

                <Form.Item
                    name="انتخاب محتوا"
                    label="انتخاب محتوا"
                    style={{ width: "100%" }}
                >
                    <Select
                        defaultValue={
                            selectedTravelId
                                ? travelContent.map((c) => c.title)
                                : []
                        }
                        mode="multiple"
                        style={{
                            width: "100%",
                        }}
                        onChange={handleChangeContent}
                        tokenSeparators={[","]}
                        options={selectContent}
                    />
                </Form.Item>
                <Form.Item
                    name="انتخاب شهر/روستا"
                    label="انتخاب شهر/روستا"
                    style={{ width: "100%" }}
                >
                    <Select
                        defaultValue={
                            selectedTravelId ? travelGeo.map((g) => g.name) : []
                        }
                        mode="multiple"
                        style={{
                            width: "100%",
                        }}
                        onChange={handleChangeGeo}
                        tokenSeparators={[","]}
                    >
                        {selectGeo.map((g, key) => {
                            return (
                                <Select.Option value={g.value} key={key}>
                                    {g.value}
                                </Select.Option>
                            );
                        })}
                    </Select>
                </Form.Item>

                <Form.Item name="تگ" label="تگ ها">
                    <div>
                        <ModalTags section="travel" />
                    </div>
                </Form.Item>
                <Form.Item name="ویرایشگر متن">
                    <Button
                        onClick={() => setTextEditorShow(true)}
                        type="primary"
                    >
                        ویرایشگر متن
                    </Button>
                </Form.Item>
            </Form>
            <TextEditorModal />
        </div>
    );
};

export default TravelForm;
